




































































import {
  computed,
  defineComponent,
  ref
} from '@vue/composition-api'

import { RoutePath as routes, RouteName as routeNames } from '@/router'
import { applyReactInVueWithOptions } from '@/utils/react.utils'
import { GrootContainer, GrootNavigationLink } from 'groot-components'

export default defineComponent({
  components: {
    GrootNavigationLink: applyReactInVueWithOptions(GrootNavigationLink),
    GrootContainer: applyReactInVueWithOptions(GrootContainer)
  },
  setup (_, context) {
    const mobileMenuVisible = ref<boolean>(false)
    const mobileWrapperPageOverlay = ref<HTMLElement | null>(null)
    const mobileWrapper = ref<HTMLElement | null>(null)

    const currentRoute = computed(() => context.root.$route)
    const isCurrentRouteLandlord = computed(() => currentRoute.value.path.includes(routes.LandlordPage))

    const handleMobileMenuState = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      const overlayClicked = target === mobileWrapperPageOverlay.value
      const navigationClicked = target.tagName === 'A' || target.tagName === 'IMG'

      if (overlayClicked || navigationClicked) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        toggleMobileMenu()
      }
    }

    const toggleMobileMenu = () => {
      mobileMenuVisible.value = !mobileMenuVisible.value
      document.body.style.overflow = mobileMenuVisible.value ? 'hidden' : 'visible'

      if (mobileMenuVisible.value) {
        mobileWrapperPageOverlay.value?.addEventListener('click', handleMobileMenuState)
      } else {
        mobileWrapperPageOverlay.value?.removeEventListener('click', handleMobileMenuState)
      }
    }

    const visibleNavigationItems = computed(() => {
      if (isCurrentRouteLandlord.value) {
        return [{
          key: 'landlord-order',
          label: 'Beställ',
          isActive: currentRoute.value.path === routes.LandlordOrderOrganisation,
          onClick: () => context.root.$router.push(routes.LandlordOrderOrganisation)
        }, {
          key: 'landlord-contact',
          label: 'Kontakt',
          isActive: currentRoute.value.path === routes.LandlordContactPage,
          onClick: () => context.root.$router.push(routes.LandlordContactPage)
        }]
      }

      return [
        {
          key: 'order-page',
          label: 'Beställ',
          isActive: currentRoute.value.path === routes.OrderPage,
          onClick: () => context.root.$router.push(routes.OrderPage)
        },
        {
          key: 'where-do-you-live',
          label: 'Min anslutning',
          isActive: currentRoute.value.path === routes.WhereDoYouLivePage,
          onClick: () => context.root.$router.push(routes.WhereDoYouLivePage)
        },
        {
          key: 'service-providers',
          label: 'Tjänsteleverantörer',
          isActive: currentRoute.value.path === routes.ServiceProviders,
          onClick: () => context.root.$router.push(routes.ServiceProviders)
        },
        {
          key: 'support',
          label: 'Kundtjänst',
          isActive: currentRoute.value.path === routes.SupportPage,
          onClick: () => context.root.$router.push(routes.SupportPage)
        }
      ]
    })

    return {
      routes,
      routeNames,
      mobileMenuVisible,
      isCurrentRouteLandlord,
      toggleMobileMenu,
      handleMobileMenuState,
      mobileWrapperPageOverlay,
      mobileWrapper,
      visibleNavigationItems
    }
  }
})
